// extracted by mini-css-extract-plugin
module.exports = {"UpcomingLaunchesHeading":"AuiY0J92pYLWoTuJOZs1w","Line":"_1iBw1Xtc6Rwt6KQFQHqXJ","title":"_1Q9OFkU6Lwfw4o7AMP5-jy"};